import { render, staticRenderFns } from "./offline_purchase_list.vue?vue&type=template&id=0c1ed6c4&scoped=true"
import script from "./offline_purchase_list.vue?vue&type=script&lang=js"
export * from "./offline_purchase_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ed6c4",
  null
  
)

export default component.exports